/**
 * @fileoverview STORY セクションのエピソード切り替えを制御する
 * @description サムネイルクリックでメイン画像とテキストを切り替え、
 *              同時にメイン画像エリア（#js-story-main-image）へスムーズスクロールする。
 *              FILEタブクリックでエピソードグループを切り替え、先頭エピソードを自動選択する。
 *
 * @limitations STORYセクション（#story）が存在しない場合は何も行わない。
 */

document.addEventListener('DOMContentLoaded', () => {
	const story = document.getElementById('story');
	if (!story) return;

	const thumbs = story.querySelectorAll('.p-home-story__episode-thumb');
	if (!thumbs.length) return;

	const left = story.querySelector('.p-home-story__left');
	const mainImages = story.querySelectorAll('[data-story-image]');
	const contents = story.querySelectorAll('[data-story-content]');
	const scrollTarget = story.querySelector('#js-story-main-image');
	const fileTabs = story.querySelectorAll('.js-story-file-tab');
	const fileGroups = story.querySelectorAll('[data-story-file-group]');
	const mq = window.matchMedia('(min-width: 768px)');

	const syncHeight = () => {
		if (!left) return;

		if (!mq.matches) {
			story.style.removeProperty('--story-left-h');
			return;
		}

		story.style.setProperty('--story-left-h', `${left.getBoundingClientRect().height}px`);
	};

	const switchEpisode = (index) => {
		thumbs.forEach((thumb) => {
			const isActive = thumb.dataset.storyTarget === index;
			thumb.classList.toggle('is-active', isActive);
			thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
		});

		mainImages.forEach((img) => {
			img.classList.toggle('is-active', img.dataset.storyImage === index);
		});

		contents.forEach((content) => {
			content.classList.toggle('is-active', content.dataset.storyContent === index);
		});

		syncHeight();
	};

	const onThumbClick = (event) => {
		const thumb = event.currentTarget;
		if (!(thumb instanceof HTMLButtonElement)) return;

		const index = thumb.dataset.storyTarget;
		if (!index) return;

		switchEpisode(index);

		if (scrollTarget && window.innerWidth < 768) {
			scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	};

	const onFileTabClick = (event) => {
		const tab = event.currentTarget;
		if (!(tab instanceof HTMLButtonElement)) return;

		const fileIndex = tab.dataset.storyFile;
		if (!fileIndex) return;

		fileTabs.forEach((t) => {
			const isActive = t.dataset.storyFile === fileIndex;
			t.classList.toggle('is-active', isActive);
			t.setAttribute('aria-selected', isActive ? 'true' : 'false');
		});

		fileGroups.forEach((group) => {
			group.classList.toggle('is-active', group.dataset.storyFileGroup === fileIndex);
		});

		const activeGroup = story.querySelector(`[data-story-file-group="${fileIndex}"]`);
		const firstThumb = activeGroup?.querySelector('.p-home-story__episode-thumb');

		if (firstThumb instanceof HTMLButtonElement) {
			const firstIndex = firstThumb.dataset.storyTarget;
			if (firstIndex) {
				switchEpisode(firstIndex);
				return;
			}
		}

		syncHeight();
	};

	thumbs.forEach((thumb) => {
		thumb.addEventListener('click', onThumbClick);
	});

	fileTabs.forEach((tab) => {
		tab.addEventListener('click', onFileTabClick);
	});

	if (left) {
		const resizeObserver = new ResizeObserver(() => {
			syncHeight();
		});
		resizeObserver.observe(left);
	}

	window.addEventListener('resize', syncHeight);
	window.addEventListener('load', syncHeight);

	syncHeight();
});
